import {
    isManifestItem,
    ManifestBase,
    ManifestDefaultImage,
    ManifestDefaultItem,
    ManifestDefaultShape,
    ManifestVideo,
} from './typesManifest';

/**
 * @deprecated only used by legacy
 */
interface LegacyManifestDefaultTextbox extends ManifestDefaultItem {
    align: string;
    shadow: boolean;
    underline: string;
    italic: string;
    bold: string;
    lineheight: string;
    font: string;
    size: string;
    color: string;
    text: string;
}
export function isLegacyManifestDefaultTextbox(
    obj: unknown,
    isLegacy: boolean
): obj is LegacyManifestDefaultTextbox {
    return obj instanceof Object && 'text' in obj && isLegacy;
}

/**
 * @deprecated only used by legacy
 */
interface LegacyManifestDefault extends ManifestBase {
    template: 'default';
    bgimg: string | null;
    textboxes: Array<LegacyManifestDefaultTextbox>;
    shapes: Array<ManifestDefaultShape>;
    images: Array<ManifestDefaultImage>;
}
export function isLegacyManifestDefault(
    item: unknown,
    isLegacy: boolean
): item is LegacyManifestDefault {
    return isManifestItem(item) && 'default' === item.template && isLegacy;
}

interface ManifestSocialMediaBase extends ManifestBase {
    reach_sm_id: number | string;

    sm_template: string; // 'a' | 'b' | 'c'
    sm_id: unknown;
}
interface ManifestFacebook extends ManifestSocialMediaBase {
    template: 'facebook';
}
interface ManifestInstagram extends ManifestSocialMediaBase {
    template: 'instagram';
}
interface ManifestTwitter extends ManifestSocialMediaBase {
    template: 'twitter';
}
/**
 * @deprecated only used by legacy
 */
type LegacyManifestSocialMedia = ManifestFacebook | ManifestInstagram | ManifestTwitter;
export function isLegacyManifestSocialMedia(
    item: unknown,
    isLegacy: boolean
): item is LegacyManifestSocialMedia {
    return (
        isManifestItem(item) &&
        ['facebook', 'instagram', 'twitter'].includes(item.template) &&
        isLegacy
    );
}

/**
 * @deprecated only used by legacy
 */
interface LegacyManifestContent extends ManifestBase {
    template: 'content';
    content_type: string | null; //"news" | "sports" | "ent" | null;
}
export function isLegacyManifestContent(
    item: unknown,
    isLegacy: boolean
): item is LegacyManifestContent {
    return isManifestItem(item) && 'content' === item.template && isLegacy;
}

/**
 * @deprecated only used by legacy
 */
type LegacyManifestItem =
    | ManifestBase
    | LegacyManifestDefault
    | ManifestVideo
    | LegacyManifestSocialMedia
    | LegacyManifestContent;

/**
 * @deprecated only used by legacy
 */
export interface LegacyAnnouncementManifest {
    announcements: Array<LegacyManifestItem>;
    hash: string;

    stage_width: number | string;
    stage_height: number | string;
}
export function isLegacyAnnouncementManifest(
    obj: unknown,
    isLegacy: boolean
): obj is LegacyAnnouncementManifest {
    return obj instanceof Object && isLegacy;
}
